import React, { useMemo, useState } from "react"

import Bot from "../.."
import { SettingsDialog } from "../../../../../components"
import { STEPS } from "../../../../../enums/ateliers"
import { SettingsPageLayout } from "../../../../../layouts"
import { BOT_PARAMS_DEFAULT_VALUES } from "../../config/default"
import { story } from "./story"

const EnqueteNoel = () => {
  const [params, setParams] = useState(BOT_PARAMS_DEFAULT_VALUES)

  const dialogIsOpen = useMemo(() => params.step !== STEPS.ATELIER, [params])

  return (
    <>
      {params.step === STEPS.ATELIER && (
        <Bot params={params} setParams={setParams} story={story} />
      )}

      <SettingsDialog open={dialogIsOpen}>
        {params.step === STEPS.PRESENTATION && (
          <SettingsPageLayout
            title="PRESENTATION"
            buttonText="SUIVANT"
            buttonAction={() =>
              setParams({ ...params, step: STEPS.PARAMETRES })
            }
          >
            TODO _
          </SettingsPageLayout>
        )}
        {params.step === STEPS.PARAMETRES && (
          <SettingsPageLayout
            title="PARAMETRES"
            buttonText="SUIVANT"
            buttonAction={() => setParams({ ...params, step: STEPS.ATELIER })}
          >
            TODO _
          </SettingsPageLayout>
        )}
        {params.step === STEPS.RESULTATS && (
          <SettingsPageLayout
            title="RESULTATS"
            buttonText="SUIVANT"
            buttonAction={() =>
              setParams({ ...params, step: STEPS.PARAMETRES })
            }
          >
            TODO _
          </SettingsPageLayout>
        )}
      </SettingsDialog>
    </>
  )
}

export default EnqueteNoel
